import axios from 'axios'
import type { priority, addpriority, pagination } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'priority'

export const readPriorityListAPI = async (pagination: pagination): Promise<priority[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
      ...pagination
    }
  })
  console.log("readPriorityListAPI 응답:", response.data)
  return response.data.data

}

export const addPriorityAPI = async (priority: addpriority): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'add',
     ...priority
    }
  })
  console.log("addPriorityAPI 응답:", response.data)
  return response.data
}

export const updatePriorityAPI = async (priority: priority): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      ...priority
    }
  })
  console.log("updatePriorityAPI 응답:", response.data)
  return response.data
}

export const deletePriorityAPI = async (id: number): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      id: id,
    }
  })
  console.log("deletePriorityAPI 응답:", response.data)
  return response.data
}

export const paginationPriorityAPI = async (size: number): Promise<number> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'pagination',
      size: size,
    }
  })
  console.log("paginationPriorityAPI 응답:", response.data)
  return response.data.data.totalpage
}